var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 116 92",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#3E87CB",
    x: 1,
    y: 25,
    width: 30,
    height: 66
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#3E87CB",
    x: 31,
    y: 25,
    width: 84,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#3E87CB",
    x: 31,
    y: 55,
    width: 84,
    height: 36
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#F89B55",
    x: 1,
    y: 1,
    width: 114,
    height: 24
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#F89B55",
    cx: 13,
    cy: 13,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#F89B55",
    cx: 26,
    cy: 13,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#F89B55",
    cx: 39,
    cy: 13,
    r: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiIcon);
export default __webpack_public_path__ + "static/media/ui-icon.28dd71c5b8faac3f4e5ea3aa32cad666.svg";
export { ForwardRef as ReactComponent };